import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { MenuItemId } from '@/constants/menuItems';

interface SidebarStore {
  currentExpandedParentMenuItem: MenuItemId | null;
  currentHighlightedParentMenuItem: MenuItemId | null;
  handleToggleExpandedMenuItem: (id: MenuItemId) => void;
  setCurrentExpandedParentMenuItem: (id: MenuItemId) => void;
  setCurrentHighlightedParentMenuItem: (id: MenuItemId) => void;
  resetExpandedAndHighlightedMenuItems: () => void;
}

export const useSidebarStore = create<SidebarStore>()(
  devtools((set) => ({
    currentExpandedParentMenuItem: null,
    currentHighlightedParentMenuItem: null,
    handleToggleExpandedMenuItem: (id: MenuItemId) => {
      set(
        (state) => ({
          currentExpandedParentMenuItem:
            state.currentExpandedParentMenuItem === id ? null : id,
        }),
        undefined,
        'sidebar/handleToggleExpandedMenuItem',
      );
    },
    setCurrentExpandedParentMenuItem: (id: MenuItemId) => {
      set(
        { currentExpandedParentMenuItem: id },
        undefined,
        'sidebar/setCurrentExpandedParentMenuItem',
      );
    },
    setCurrentHighlightedParentMenuItem: (id: MenuItemId) => {
      set(
        { currentHighlightedParentMenuItem: id },
        undefined,
        'sidebar/setCurrentHighlightedParentMenuItem',
      );
    },
    resetExpandedAndHighlightedMenuItems: () =>
      set(
        {
          currentExpandedParentMenuItem: null,
          currentHighlightedParentMenuItem: null,
        },
        undefined,
        'sidebar/resetExpandedAndHighlightedMenuItems',
      ),
  })),
);
